import api from './axiosConfig';

export async function printBarcodeLabels(deviceIds = []) {
  if (!Array.isArray(deviceIds) || deviceIds.length === 0) {
    throw new Error('Yazdırılacak cihaz seçilmedi.');
  }

  const response = await api.post('/it-inventory/devices/barcodes', {
    device_ids: deviceIds,
  });

  const barcodeData = response.data.devices || [];

  if (barcodeData.length === 0) {
    throw new Error('Yazdırılacak barkod verisi bulunamadı.');
  }

  const printWindow = window.open('', '_blank');

  if (!printWindow) {
    throw new Error('Yazdırma penceresi açılamadı. Tarayıcı popup engelliyor olabilir.');
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Barkod Etiketi Yazdır</title>
      <style>
        @page {
          size: A4 portrait;
          margin: 14mm 5mm 2mm 5mm;
        }

        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; padding-left: 2px; margin-top: 4px; font-family: Arial, sans-serif; }

        .barcode-container {
          display: grid;
          grid-template-columns: repeat(3, 64mm);
          grid-auto-rows: 34mm;
          column-gap: 3mm;
          row-gap: 0;
          width: calc(64mm * 3 + 3mm * 2);
          margin: 0 auto;
          padding: 0;
        }

        .barcode-item {
          position: relative;
          width: 64mm;
          height: 34mm;
          padding: 2mm 2.2mm 1.6mm;
          overflow: hidden;
          page-break-inside: avoid;
        }

        .device-info {
          font-size: 9.5pt;
          font-weight: 700;
          line-height: 1.1;
          margin: 0 0 1mm;
          text-align: center;
        }

        .device-serial {
          font-size: 7.5pt;
          color: #555;
          text-align: center;
        }

        .logo-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2mm;
          margin-top: 0.6mm;
        }

        .logo {
          width: 12mm;
          height: 12mm;
          object-fit: contain;
        }

        .barcode-svg {
          width: 100%;
          height: 15mm;
          display: block;
        }

        @media print {
          .barcode-item:nth-child(24n) { break-after: page; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      </style>
    </head>
    <body>
      <div class="barcode-container">
        ${barcodeData.map(device => `
          <div class="barcode-item">
            <div class="device-info">${device.device_type}-${device.brand}</div>
            <svg class="barcode-svg" id="barcode-${device.id}"></svg>
            <div class="logo-container">
              <img src="logo.png" alt="Logo" class="logo">
              <div class="device-serial">SMS GRUP İNŞAAT A.Ş.</div>
            </div>
          </div>
        `).join('')}
      </div>

      <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
      <script>
        ${barcodeData.map(device => `
          JsBarcode("#barcode-${device.id}", "${device.barcode}", {
            format: "CODE128",
            width: 1.5,
            height: 40,
            displayValue: true,
            fontSize: 10,
            margin: 2,
            textMargin: 2,
            fontOptions: "bold"
          });
        `).join('')}

        setTimeout(() => {
          window.print();
        }, 1000);
      </script>
    </body>
    </html>
  `);

  printWindow.document.close();
}